import { PropsWithChildren } from 'react'
import cx from 'classnames'
import Styles from './TabPanel.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'
import { ArrowLeft } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Text } from 'blaze-ui/Text/Text'
import { useTabPanelScrolled } from './TabPanel'

interface HeaderProps {
  onBack?: () => any
  title?: string
  onClose?: () => any
}

const DesktopHeader = ({ onBack, children, title, onClose }: PropsWithChildren<HeaderProps>) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const isScrolled = useTabPanelScrolled()

  return (
    <div className={cx(Styles.header, { [Styles.scrolled]: isScrolled })}>
      {(onBack || title) && (
        <div className={Styles.titleRow}>
          {onBack && (
            <IconButton
              aria-label="Back"
              onPress={onBack}
              icon={ArrowLeft}
              size={isSystemRedesignEnabled ? 'sm' : 'xs'}
              variant={isSystemRedesignEnabled ? 'secondary' : 'tertiary'}
            />
          )}
          {title && (
            <div className={Styles.title}>
              {isSystemRedesignEnabled ? <Text>{title}</Text> : <Heading level={4}>{title}</Heading>}
            </div>
          )}
          {onClose && (
            <div className={Styles.closeButton}>
              <IconButton icon={Close} size="xs" variant="tertiary" onPress={onClose} />
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  )
}

const MobileHeader = ({ children }: PropsWithChildren<HeaderProps>) => {
  const isScrolled = useTabPanelScrolled()
  return !!children ? <div className={cx(Styles.header, { [Styles.scrolled]: isScrolled })}>{children}</div> : null
}

const HeaderContainer = (props: PropsWithChildren<HeaderProps>) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileHeader {...props} /> : <DesktopHeader {...props} />
}

export { HeaderContainer as Header }
